export default "__VITE_ASSET__IB4XAgWF__"